export enum InventoryItemKind {
  Product = "PRODUCT",
  Return = "RETURN",
  Undeclared = "UNDECLARED",
  Unknown = "UNKNOWN",
}
